// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__swaxo","col":"CardReaderDesc_col__37MKU","label":"CardReaderDesc_label__fgQNj"};